import axios from 'axios';
import { useStore } from '../../../store';
import { showMoreCheckout } from './showMoreCheckout';
import { getNews } from './getNews';
import { resetNews } from './resetNews';
import { getUrl } from './getUrl';

const store = useStore();

export const search = () => {
    store.commit('press/SET_PAGE_NUMBER', 1);
    if (!store.state.press.searchActive) {
        resetNews();
    }

    if (store.state.press.filterCode) {
        store.commit('press/CHANGE_FILTER', '');
    }

    store.commit('press/SET_LOADING', true);
    const activeFlag = store.state.press.searchValue.trim() !== '' ? true : false;
    store.commit('press/CHANGE_SEARCH', activeFlag);
    let url = getUrl();
    axios.get(url)
        .then((res) => {
            if (res.data.data.length >= 1) {
                const articles = !store.state.press.news.length ? res.data.data : [...store.state.press.news, ...res.data.data];
                store.commit('press/SET_NEWS', articles);
                store.commit('press/SET_SEARCH_ERROR', false);
            }
            else {
                store.commit('press/SET_SEARCH_ERROR', true);
            }

            store.commit('press/SET_LOADING', false);

            if (store.state.press.searchActive) {
                showMoreCheckout(res.data.meta.totalPages);
            }
            else {
                resetNews();
                getNews();
            }
        })
}
